// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"87":"1ddfbbb0","854":"1ddfbbb0"}[chunkId] + ".css";
};